class AATagging {
    static trackSignin() {
        window.digitalData = {
            page: {
                pageName: "Signin",
                platform: "Line LIFF",
                loginStatus: "No",
            },
            journey: {
                journeyName: "Signin Journey"
            },
            user: {
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('pageView');
        }, 500)
    }

    static trackSignup() {
        window.digitalData = {
            page: {
                pageName: "Signup",
                platform: "Line LIFF",
                loginStatus: "No",
            },
            journey: {
                journeyName: "Signup Journey"
            },
            user: {
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('pageView');
        }, 500)
    }

    static trackSigninComplete(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "SignupSignin-Complete",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('pageView');
            setTimeout(() => {
                window._satellite && window._satellite.track('successfulSignupSignin');
            }, 500)
        }, 500)
    }


    static trackSigninCompleteBackToLine(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "SignupSignin-Complete",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            link: {
                linkName: "Back to LINE",
                linkposition: "Back TextLink",
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('linkTracking');
        }, 500)
    }

    static trackSigninCompletGetTheApp(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "SignupSignin-Complete",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            link: {
                linkName: "Get The 1 app",
                linkposition: "CTA Button",
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('linkTracking');
        }, 500)
    }

    static trackAlreadyLink(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Already Linked Account",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            journey: {
                journeyName: "Signin Journey"
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('pageView');
        }, 500)
    }


    static trackAlreadyLinkCreateThe1(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Already Linked Account",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            journey: {
                journeyName: "Signin Journey"
            },
            link: {
                linkName: "Create your own The 1 account",
                linkposition: "CTA Button",
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('linkTracking');
        }, 500)
    }

    static trackAlreadyLinkUnlink(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Already Linked Account",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            link: {
                linkName: "Unlink my The 1 account with previous LINE ID",
                linkposition: "CTA Button",
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('linkTracking');
        }, 500)
    }


    static trackAlreadyLinkUnlinkComplete(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Unlink-Complete",
                platform: "Line LIFF",
                loginStatus: "No",
                // memberID,
            },
            user: {
                // userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)

        setTimeout(() => {
            window._satellite && window._satellite.track('pageView');
            setTimeout(() => {
                window._satellite && window._satellite.track('unlinkAccount');
            }, 500)
        }, 500)
    }
    static trackViewProfile(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Account Setting",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('pageView');
        }, 500)
    }

    static trackViewProfilePinConfig(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Account Setting",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            link: {
                linkName: "The 1 Application",
                linkposition: "The 1 Application TextLink",
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('linkTracking');
        }, 500)
    }


    static trackViewProfileGoToApp(memberID, isT1X) {
        window.digitalData = {
            page: {
                pageName: "Account Setting",
                platform: "Line LIFF",
                loginStatus: "Yes",
                memberID,
            },
            link: {
                linkName: "Go",
                linkposition: "CTA Button",
            },
            user: {
                userType: isT1X ? "T1X Member" : "Non-T1X Member",
            }
        }
        // console.log(window.digitalData)
        setTimeout(() => {
            window._satellite && window._satellite.track('linkTracking');
        }, 500)
    }
}

export default AATagging